class SpotifyRequestError extends Error {
  constructor(error) {
    const { message, status, statusCode } = error;
    super(message);
    if (status === 401) {
      this.name = 'Unauthorized';
      this.status = status;
    } else if (statusCode === 400) {
      this.name = 'Bad Request';
      this.status = statusCode;
    }
  }
}

export default SpotifyRequestError;
